import { Helmet } from "react-helmet";
import PageBanner from "../../components/body/PageBanner";
import { APP_NAME } from "../../utils/appName";
import Form from "../../components/form/Form";

function ComplaintsBook() {
  return (
    <>
      <Helmet>
        <title>Libro de Reclamaciones - {APP_NAME}</title>
      </Helmet>
      <PageBanner
        title="Servicios"
        subtitle="Libro de Reclamaciones"
        parent_link="/servicios"
      />
      <section className="tp-checkout-area pb-50 pt-80">
        <Form
          title="Libro de Reclamaciones"
          subtitle="¿Tienes alguna queja o reclamo que desees presentar?"
          next_link="https://www.munilalibertaddepallan.gob.pe/servicios/libro-de-reclamaciones"
        />
      </section>
    </>
  );
}

export default ComplaintsBook;
